<script>
	// Custom line mark for the Legends of Tasmania experience grid. Drawn to the
	// same geometry as the lucide set used elsewhere (24px box, 1.5 stroke,
	// round caps) so it sits naturally beside them.
	let { class: className = '' } = $props();
</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	viewBox="0 0 24 24"
	fill="none"
	stroke="currentColor"
	stroke-width="1.5"
	stroke-linecap="round"
	stroke-linejoin="round"
	class={className}
	aria-hidden="true"
>
	<rect x="9" y="3.6" width="9.6" height="13.4" rx="1.8" transform="rotate(14 13.8 10.3)" />
	<rect x="5.2" y="6.6" width="9.6" height="13.4" rx="1.8" />
	<path d="m10 11.4 1.3 1.9-1.3 1.9-1.3-1.9z" />
</svg>
